// extracted by mini-css-extract-plugin
export default {"record_form":"Records_record_form__MpUkK","records":"Records_records__8RYjB"};